import React from "react";
import {AiOutlineLoading3Quarters} from "react-icons/ai"
function LoadingX({color}) {
  return (
    <AiOutlineLoading3Quarters className={`mx-auto  animate-spin text-2xl ${color}`} />
  );
}

export default LoadingX;
